export class Common {
    // public static baseUrl = 'https://localhost:44371';
    // public static baseUrl = 'https://localhost:44343';
    public static baseUrl = 'http://103.121.78.28:219';
    // public static baseUrl = 'http://192.168.0.10:81';

}
